module.exports = __webpack_public_path__ + "static/img/Inspection23.9651be1a.jpg";